/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const UPLOAD_FILE = gql`
  mutation UploadFile($name: String!, $data: String!, $category1: String, $category2: String, $addBandName: Boolean) {
    uploadFile(name: $name, data: $data, category1: $category1, category2: $category2, addBandName: $addBandName)
  }
`;
